import serverData from './server-data'

const features = serverData.features

const hasFeature = (featureName: string) => {
  return !!features?.[featureName]
}

export const isGroupCreationEnabled = () => {
  return hasFeature('groupsExperience')
}

export const isCoverOnCreateFlowEnabled = () => {
  return hasFeature('isCoverOnCreateFlowEnabled')
}

export const isDetailsV1Dot1Enabled = () => {
  return (
    isCoverOnCreateFlowEnabled() ||
    (!serverData?.user && hasFeature('isCoverOnCreateFlowGuestEnabled'))
  )
}

export const isEmbeddedAnonymousAmount = () => {
  return (
    hasFeature('isEmbeddedAnonymousAmountEnabled') ||
    hasFeature('isEmbeddedAnonymousAmountEnabledGuest')
  )
}

export const isUserTypeAgnosticIntroEnabled = () => {
  return (
    hasFeature('isUserTypeAgnosticIntroEnabled') ||
    (!serverData?.user && hasFeature('isUserTypeAgnosticIntroEnabledGuest'))
  )
}

export const isUserSpecificEaseOfUseIntroEnabled = () => {
  return (
    hasFeature('isUserSpecificEaseOfUseIntroEnabled') ||
    (!serverData?.user &&
      hasFeature('isUserSpecificEaseOfUseIntroEnabledGuest'))
  )
}

export const isUserSpecificTransparencyEnabled = () => {
  return (
    hasFeature('isUserSpecificTransparencyEnabled') ||
    (!serverData?.user && hasFeature('isUserSpecificTransparencyEnabledGuest'))
  )
}
export const isTileAndSheetAnonymousAmount = () => {
  return (
    hasFeature('isTileAndSheetAnonymousAmountEnabled') ||
    hasFeature('isTileAndSheetAnonymousAmountEnabledGuest')
  )
}

export const isAnonymousAmountEnabled = () => {
  return isEmbeddedAnonymousAmount() || isTileAndSheetAnonymousAmount()
}
